import { get, writable } from 'svelte/store';

import { MODULE_ENUM, type LoginModuleType } from '../enums/loginModule';

export const currentModule = writable<LoginModuleType>(MODULE_ENUM.CODE);
export const pendingLoginModule = writable<LoginModuleType>(MODULE_ENUM.CODE);
export const loginPhoneNumber = writable('');
export const isFromPictureModule = writable(false);
export const codeCountdown = writable(0);
export const loginFlowLoading = writable(false);
/** 验证码页返回时恢复输入（与 MXLogin 行为一致，避免 remount 后变 0/6） */
export const codeInputSnapshot = writable('');
export const isCodeVerifySuccessState = writable(false);
export const pageModuleEnterTime = writable<number | null>(null);
/** 模块内切换时跳过验证码页 loginFail（如跳转图形码页） */
export const suppressCodeModuleLoginFail = writable(false);
/** 最近一次发送短信验证码的时间（performance.now），供 loading/typing 埋点计时 */
export const codeSendTime = writable(0);

/** 落地页点击 CTA 到验证码页加载的起始时间（performance.now） */
export const verificationCodeLoadingStartTime = writable<number | null>(null);

let codeCountdownTimer: ReturnType<typeof setInterval> | null = null;

export const markVerificationCodeLoadingStart = () => {
    verificationCodeLoadingStartTime.set(window.performance.now());
};

export const clearVerificationCodeLoadingStart = () => {
    verificationCodeLoadingStartTime.set(null);
};

export const consumeVerificationCodeLoadingStart = () => {
    const startTime = get(verificationCodeLoadingStartTime);

    verificationCodeLoadingStartTime.set(null);

    return startTime;
};

export const markCodeSent = () => {
    codeSendTime.set(window.performance.now());
};

export const clearCodeInputState = () => {
    codeInputSnapshot.set('');
    isCodeVerifySuccessState.set(false);
};

export const persistCodeInputState = (digits: string, verified: boolean) => {
    codeInputSnapshot.set(digits.replace(/\D/g, '').slice(0, 6));
    isCodeVerifySuccessState.set(verified);
};

export const startCodeCountdown = () => {
    if (codeCountdownTimer) {
        clearInterval(codeCountdownTimer);
    }

    codeCountdown.set(59);
    codeCountdownTimer = setInterval(() => {
        codeCountdown.set(get(codeCountdown) - 1);

        if (get(codeCountdown) <= 0) {
            stopCodeCountdown();
        }
    }, 1000);
};

export const stopCodeCountdown = () => {
    if (codeCountdownTimer) {
        clearInterval(codeCountdownTimer);
        codeCountdownTimer = null;
    }
};

export const setLoginFlowLoading = (value: boolean) => {
    loginFlowLoading.set(value);
};

export const changeModule = (module: LoginModuleType) => {
    const previousModule = get(currentModule);

    if (module === MODULE_ENUM.CODE && previousModule === MODULE_ENUM.PICTURE) {
        isFromPictureModule.set(true);
    } else {
        isFromPictureModule.set(false);
    }

    suppressCodeModuleLoginFail.set(true);
    currentModule.set(module);

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

/** 落地页进入 /login 前重置模块状态，避免残留 PICTURE 状态误判为图形码跳转 */
export const prepareLoginFlowNavigation = (
    module: LoginModuleType,
    phone: string
) => {
    loginPhoneNumber.set(phone);
    pendingLoginModule.set(module);
    currentModule.set(module);
    isFromPictureModule.set(false);
    pageModuleEnterTime.set(window.performance.now());

    if (module !== MODULE_ENUM.CODE) {
        clearVerificationCodeLoadingStart();
    }
};

export const resetLoginFlow = () => {
    stopCodeCountdown();
    currentModule.set(MODULE_ENUM.CODE);
    pendingLoginModule.set(MODULE_ENUM.CODE);
    isFromPictureModule.set(false);
    codeCountdown.set(0);
    loginFlowLoading.set(false);
    clearCodeInputState();
    codeSendTime.set(0);
    pageModuleEnterTime.set(null);
    suppressCodeModuleLoginFail.set(false);
    clearVerificationCodeLoadingStart();
};
